import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__classifieds_edit',
    path: '/classifieds/:classifiedId/edit/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/edit/edit.vue' /* webpackChunkName: "pages-classifieds-edit-edit" */
        )
      ),
    redirect: { name: '__classifieds_edit_details' },
    children: [
      {
        path: 'details/',
        name: '__classifieds_edit_details',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/details.vue' /* webpackChunkName: "pages-classifieds-edit-details" */
            )
          ),
        pathToRegexpOptions: { strict: true },
        meta: {
          showOneTap: true,
          hideMobileBottomMenu: true
        }
      },
      {
        path: 'charges/',
        name: '__classifieds_edit_charges',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/charges.vue' /* webpackChunkName: "pages-classifieds-edit-charges" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      },
      {
        path: 'certificates/',
        name: '__classifieds_edit_certificates',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/certificates.vue' /* webpackChunkName: "pages-classifieds-edit-certificates" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      },
      {
        path: 'statistics/',
        name: '__classifieds_edit_statistics',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/statistics.vue' /* webpackChunkName: "pages-classifieds-edit-statistics" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      },
      {
        path: 'messages/',
        name: '__classifieds_edit_messages',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/messages.vue' /* webpackChunkName: "pages-classifieds-edit-messages" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      },
      {
        path: 'eshop/',
        name: '__classifieds_edit_eshop',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/eshop.vue' /* webpackChunkName: "pages-classifieds-edit-eshop" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      },
      {
        path: 'trades/',
        name: '__classifieds_edit_trades',
        component: () =>
          interopDefault(
            import(
              '~/pages/car/classifieds/edit/trades.vue' /* webpackChunkName: "pages-classifieds-edit-trades" */
            )
          ),
        meta: {
          ignoreScrollBehavior: true
        }
      }
    ]
  }
]
